import React from 'react';
import { Link } from 'react-router-dom';
import { Car } from 'lucide-react';
import siteConfig from '../config';

const Brands = () => {
  const linkableBrands = ['Mercedes-Benz', 'BMW', 'Audi'];
  
  return (
    <section className="py-20 bg-gradient-to-br from-black via-gray-950 to-black relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Brands We Specialize In
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-yellow-400 to-yellow-600 mx-auto mb-6"></div>
          <p className="text-gray-400 text-lg">
            Expert service for the world's finest automobiles
          </p>
        </div>

        {/* Brands Grid - Mobile Optimized */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 sm:gap-6">
          {siteConfig.brands.map((brand, index) => {
            const isLinkable = linkableBrands.includes(brand.name);
            const slug = brand.name.toLowerCase().replace(/-/g, '-').replace(/\s+/g, '-');
            const content = (
              <div className="flex flex-col items-center justify-center space-y-4">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <Car className="w-8 h-8 text-black" />
                </div>
                <h3 className="text-white font-bold text-center group-hover:text-yellow-400 transition-colors duration-300">
                  {brand.name}
                </h3>
              </div>
            );
            
            return isLinkable ? (
              <Link
                key={index}
                to={`/services/${slug}`}
                className="group bg-white/5 backdrop-blur-sm border border-yellow-500/20 rounded-2xl p-6 hover:bg-white/10 hover:border-yellow-500/50 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-yellow-500/20 cursor-pointer"
              >
                {content}
              </Link>
            ) : (
              <div
                key={index}
                className="group bg-white/5 backdrop-blur-sm border border-yellow-500/20 rounded-2xl p-6 hover:bg-white/10 hover:border-yellow-500/50 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-yellow-500/20"
              >
                {content}
              </div>
            );
          })}
        </div>

        {/* Bottom Note */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 text-lg">
            And many more luxury European vehicles
          </p>
        </div>
      </div>
    </section>
  );
};

export default Brands;
